"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyCode = void 0;
/**
 * @enum CurrencyCode
 */
const CurrencyCode = {
    YUBTRUB: 'YUBTRUB',
    IQD: 'IQD',
    WMH: 'WMH',
    EUR: 'EUR',
    USD: 'USD',
    ZPRUB: 'ZPRUB',
    CARDTHB: 'CARDTHB',
    CRCPTLUSD: 'CRCPTLUSD',
    AMD: 'AMD',
    AUD: 'AUD',
    BYN: 'BYN',
    BRL: 'BRL',
    CAD: 'CAD',
    SWIFTEUR: 'SWIFTEUR',
    CLP: 'CLP',
    NZD: 'NZD',
    EGP: 'EGP',
    YOBITUSD: 'YOBITUSD',
    EOS: 'EOS',
    YOBITRUB: 'YOBITRUB',
    SVC: 'SVC',
    RUSSTRUB: 'RUSSTRUB',
    TCSBRUB: 'TCSBRUB',
    YUBTUSD: 'YUBTUSD',
    UNVBUAH: 'UNVBUAH',
    GGP: 'GGP',
    HKD: 'HKD',
    FRTBKZT: 'FRTBKZT',
    IRR: 'IRR',
    MONOBUAH: 'MONOBUAH',
    KGS: 'KGS',
    SWIFTUSD: 'SWIFTUSD',
    CNY: 'CNY',
    GBP: 'GBP',
    GEL: 'GEL',
    IDR: 'IDR',
    ILS: 'ILS',
    KRW: 'KRW',
    KZT: 'KZT',
    WEXETH: 'WEXETH',
    MGFNBRUB: 'MGFNBRUB',
    P24EUR: 'P24EUR',
    XCD: 'XCD',
    XOF: 'XOF',
    USBUAH: 'USBUAH',
    INR: 'INR',
    NOK: 'NOK',
    XAF: 'XAF',
    COU: 'COU',
    CUC: 'CUC',
    STN: 'STN',
    SCR: 'SCR',
    ANG: 'ANG',
    DKK: 'DKK',
    GIP: 'GIP',
    ASKBTCUSD: 'ASKBTCUSD',
    SBD: 'SBD',
    SSP: 'SSP',
    SEK: 'SEK',
    CHE: 'CHE',
    KPW: 'KPW',
    KWD: 'KWD',
    LAK: 'LAK',
    LSL: 'LSL',
    MYR: 'MYR',
    IMP: 'IMP',
    MRU: 'MRU',
    MXN: 'MXN',
    CHW: 'CHW',
    MXV: 'MXV',
    MDL: 'MDL',
    MAD: 'MAD',
    RON: 'RON',
    HRK: 'HRK',
    RUB: 'RUB',
    HUF: 'HUF',
    PLN: 'PLN',
    ZAR: 'ZAR',
    AOA: 'AOA',
    AWG: 'AWG',
    TRY: 'TRY',
    STD: 'STD',
    BBD: 'BBD',
    BZD: 'BZD',
    TMT: 'TMT',
    BOV: 'BOV',
    CDF: 'CDF',
    FKP: 'FKP',
    FJD: 'FJD',
    XPF: 'XPF',
    GMD: 'GMD',
    CHF: 'CHF',
    USN: 'USN',
    UYI: 'UYI',
    MWK: 'MWK',
    PGK: 'PGK',
    SHP: 'SHP',
    UYW: 'UYW',
    ERN: 'ERN',
    XSU: 'XSU',
    LKR: 'LKR',
    JEP: 'JEP',
    MKD: 'MKD',
    VEF: 'VEF',
    PKR: 'PKR',
    SDG: 'SDG',
    SRD: 'SRD',
    SYP: 'SYP',
    TWD: 'TWD',
    TOP: 'TOP',
    TJS: 'TJS',
    UZS: 'UZS',
    TZS: 'TZS',
    TND: 'TND',
    PRRUB: 'PRRUB',
    BSD: 'BSD',
    AKBRSBRUB: 'AKBRSBRUB',
    CNSBKUSD: 'CNSBKUSD',
    BTN: 'BTN',
    RSSBRUB: 'RSSBRUB',
    CLF: 'CLF',
    EDR: 'EDR',
    WML: 'WML',
    EPSUSD: 'EPSUSD',
    SAR: 'SAR',
    MRO: 'MRO',
    ETB: 'ETB',
    KRGSRBTHB: 'KRGSRBTHB',
    NXUSD: 'NXUSD',
    WCUSD: 'WCUSD',
    SLL: 'SLL',
    SZL: 'SZL',
    OTPBRUB: 'OTPBRUB',
    TTD: 'TTD',
    CASHEUR: 'CASHEUR',
    GNF: 'GNF',
    GYD: 'GYD',
    XDR: 'XDR',
    LBP: 'LBP',
    LRD: 'LRD',
    LYD: 'LYD',
    XUA: 'XUA',
    MNT: 'MNT',
    NPR: 'NPR',
    QAR: 'QAR',
    WST: 'WST',
    VUV: 'VUV',
    ZWL: 'ZWL',
    MOP: 'MOP',
    MUR: 'MUR',
    THB: 'THB',
    UAH: 'UAH',
    WIREMYR: 'WIREMYR',
    ABSTBRUB: 'ABSTBRUB',
    RENBRUB: 'RENBRUB',
    HMRUB: 'HMRUB',
    LVPCAD: 'LVPCAD',
    WLDCUSD: 'WLDCUSD',
    FDOBUAH: 'FDOBUAH',
    XRP: 'XRP',
    HLXUSD: 'HLXUSD',
    CPTSUSD: 'CPTSUSD',
    KSPBDKZT: 'KSPBDKZT',
    MBDRMAMD: 'MBDRMAMD',
    ZRTBTRY: 'ZRTBTRY',
    LVCNUSD: 'LVCNUSD',
    CARDLTL: 'CARDLTL',
    PAUSD: 'PAUSD',
    BTCCDIDR: 'BTCCDIDR',
    ACEUR: 'ACEUR',
    WUUAH: 'WUUAH',
    OPAYUSD: 'OPAYUSD',
    DOP: 'DOP',
    BLRBBYR: 'BLRBBYR',
    VPIRR: 'VPIRR',
    VPAUD: 'VPAUD',
    VPEGP: 'VPEGP',
    LPGBP: 'LPGBP',
    HMUAH: 'HMUAH',
    LVPGBP: 'LVPGBP',
    WMOUSD: 'WMOUSD',
    WCTCNY: 'WCTCNY',
    WSRUB: 'WSRUB',
    BTCUPCNY: 'BTCUPCNY',
    BTCUPGBP: 'BTCUPGBP',
    BGN: 'BGN',
    VES: 'VES',
    PSRUSD: 'PSRUSD',
    VND: 'VND',
    MPLUSD: 'MPLUSD',
    PMBBUAH: 'PMBBUAH',
    ATRPUSD: 'ATRPUSD',
    SGMTUSD: 'SGMTUSD',
    MLNMBPLN: 'MLNMBPLN',
    BTCUPLTC: 'BTCUPLTC',
    LCKBRUB: 'LCKBRUB',
    EXMUAH: 'EXMUAH',
    CCBKZT: 'CCBKZT',
    GNO: 'GNO',
    ACCRUB: 'ACCRUB',
    GNT: 'GNT',
    URSBRUB: 'URSBRUB',
    NVC: 'NVC',
    EXMRUB: 'EXMRUB',
    GDPUSD: 'GDPUSD',
    BTCUPUSD: 'BTCUPUSD',
    HDUSD: 'HDUSD',
    BLRBEUR: 'BLRBEUR',
    VPRUB: 'VPRUB',
    VPNZD: 'VPNZD',
    VPMXN: 'VPMXN',
    VPTRY: 'VPTRY',
    YER: 'YER',
    LVPBYR: 'LVPBYR',
    VPIQD: 'VPIQD',
    VPJPY: 'VPJPY',
    VPSEK: 'VPSEK',
    BCBUSD: 'BCBUSD',
    CMBCNY: 'CMBCNY',
    BTPGBP: 'BTPGBP',
    BTCUPRUB: 'BTCUPRUB',
    BTCEDASH: 'BTCEDASH',
    BTCEBTC: 'BTCEBTC',
    WTCCREDS: 'WTCCREDS',
    BTCEUSD: 'BTCEUSD',
    CASHILS: 'CASHILS',
    WTPCREDS: 'WTPCREDS',
    ZMW: 'ZMW',
    ADVCEUR: 'ADVCEUR',
    SEPAEUR: 'SEPAEUR',
    TBCBUSD: 'TBCBUSD',
    RCNCRPT: 'RCNCRPT',
    DPBTC: 'DPBTC',
    ESPUAUAH: 'ESPUAUAH',
    RBKBKZT: 'RBKBKZT',
    PLUSBRUB: 'PLUSBRUB',
    CARDTRY: 'CARDTRY',
    SVCMBRUB: 'SVCMBRUB',
    TCSBUSD: 'TCSBUSD',
    VPBRL: 'VPBRL',
    LPUAH: 'LPUAH',
    LPCNY: 'LPCNY',
    CPTLEUR: 'CPTLEUR',
    ATFBUSD: 'ATFBUSD',
    EURBUSD: 'EURBUSD',
    BTPCNY: 'BTPCNY',
    DPUSD: 'DPUSD',
    VPBYR: 'VPBYR',
    XBB: 'XBB',
    BTCUPUAH: 'BTCUPUAH',
    ECPZRUB: 'ECPZRUB',
    ECPZEUR: 'ECPZEUR',
    BTAKZT: 'BTAKZT',
    ADVCKZT: 'ADVCKZT',
    CBEKR: 'CBEKR',
    PIN: 'PIN',
    CCXBTC: 'CCXBTC',
    KKBCASHKZT: 'KKBCASHKZT',
    CPTSEUR: 'CPTSEUR',
    NIXCLR: 'NIXCLR',
    LPUSD: 'LPUSD',
    ERSNBKZT: 'ERSNBKZT',
    PSREUR: 'PSREUR',
    RFBUAH: 'RFBUAH',
    XBD: 'XBD',
    EPMEUR: 'EPMEUR',
    BCN: 'BCN',
    XAU: 'XAU',
    THIBTHB: 'THIBTHB',
    SMPBRUB: 'SMPBRUB',
    SVZBRUB: 'SVZBRUB',
    MWRUB: 'MWRUB',
    UAMUSD: 'UAMUSD',
    VMUSD: 'VMUSD',
    CASHLTL: 'CASHLTL',
    SBEUR: 'SBEUR',
    USBRUB: 'USBRUB',
    VPCAD: 'VPCAD',
    VPKGS: 'VPKGS',
    VPCLP: 'VPCLP',
    VPPLN: 'VPPLN',
    LVPRUB: 'LVPRUB',
    LVPCNY: 'LVPCNY',
    LVCUSD: 'LVCUSD',
    BTPUSD: 'BTPUSD',
    SMUSD: 'SMUSD',
    BCIIDR: 'BCIIDR',
    IMBRUB: 'IMBRUB',
    GCMTRUB: 'GCMTRUB',
    XBA: 'XBA',
    EBCUR: 'EBCUR',
    EPAYEUR: 'EPAYEUR',
    MAID: 'MAID',
    IDRMAMD: 'IDRMAMD',
    NURBKZT: 'NURBKZT',
    XLM: 'XLM',
    NIXFTC: 'NIXFTC',
    HNDBRUB: 'HNDBRUB',
    SGMTEUR: 'SGMTEUR',
    USDT: 'USDT',
    ARCAAMD: 'ARCAAMD',
    BLK: 'BLK',
    ESPBYN: 'ESPBYN',
    VZRDBRUB: 'VZRDBRUB',
    NIXEUR: 'NIXEUR',
    RPUSD: 'RPUSD',
    WCEUR: 'WCEUR',
    PPTUSD: 'PPTUSD',
    VTB24USD: 'VTB24USD',
    SBERUSD: 'SBERUSD',
    NIXMSVC: 'NIXMSVC',
    KICBKGS: 'KICBKGS',
    OPAYRUB: 'OPAYRUB',
    VPCNY: 'VPCNY',
    VPKRW: 'VPKRW',
    LVPUAH: 'LVPUAH',
    TOCHRUB: 'TOCHRUB',
    RCNUSD: 'RCNUSD',
    BTCUPEUR: 'BTCUPEUR',
    BTCUPHKD: 'BTCUPHKD',
    PVTMUAH: 'PVTMUAH',
    FMBRUB: 'FMBRUB',
    XEM: 'XEM',
    BLSBBYN: 'BLSBBYN',
    WIREBYR: 'WIREBYR',
    NIXCRT: 'NIXCRT',
    BTCUPETH: 'BTCUPETH',
    CNVRSBAMD: 'CNVRSBAMD',
    BTCUPEDR: 'BTCUPEDR',
    CASHGBP: 'CASHGBP',
    WLDCEUR: 'WLDCEUR',
    EGCEUR: 'EGCEUR',
    KPTLBAZN: 'KPTLBAZN',
    AKBTRY: 'AKBTRY',
    NIXLTC: 'NIXLTC',
    LVCNRUB: 'LVCNRUB',
    TNCUSD: 'TNCUSD',
    SMSRUB: 'SMSRUB',
    VPUSD: 'VPUSD',
    VPGEL: 'VPGEL',
    VPMDL: 'VPMDL',
    CPLTUSD: 'CPLTUSD',
    PWUSD: 'PWUSD',
    CCBCNY: 'CCBCNY',
    TTRUSD: 'TTRUSD',
    WSUAH: 'WSUAH',
    PSRRUB: 'PSRRUB',
    PZUSD: 'PZUSD',
    TBKZT: 'TBKZT',
    PCDBUAH: 'PCDBUAH',
    NEOS: 'NEOS',
    BOCCNY: 'BOCCNY',
    MIRCRUB: 'MIRCRUB',
    CCXUSD: 'CCXUSD',
    DKUAH: 'DKUAH',
    XBC: 'XBC',
    PPC: 'PPC',
    STRUB: 'STRUB',
    LPEUR: 'LPEUR',
    ECNEUR: 'ECNEUR',
    MLNMBEUR: 'MLNMBEUR',
    KSPBCKZT: 'KSPBCKZT',
    VPKZT: 'VPKZT',
    VPCHF: 'VPCHF',
    HMUSD: 'HMUSD',
    LVPAUD: 'LVPAUD',
    DMRBUSD: 'DMRBUSD',
    CPTLRUB: 'CPTLRUB',
    WSUSD: 'WSUSD',
    RCN: 'RCN',
    KZVBKZT: 'KZVBKZT',
    SBRBKZRUB: 'SBRBKZRUB',
    NLMUSD: 'NLMUSD',
    EKZT: 'EKZT',
    OTPBUAH: 'OTPBUAH',
    KKBUSD: 'KKBUSD',
    OSDBUAH: 'OSDBUAH',
    KUKRUB: 'KUKRUB',
    EPMUSD: 'EPMUSD',
    MXBTC: 'MXBTC',
    TRPEUR: 'TRPEUR',
    PMREUR: 'PMREUR',
    ECNUSD: 'ECNUSD',
    EXMUSD: 'EXMUSD',
    BTCEEUR: 'BTCEEUR',
    CRTCHKUSD: 'CRTCHKUSD',
    QZQBKZT: 'QZQBKZT',
    PAEUR: 'PAEUR',
    KSSNVBKZT: 'KSSNVBKZT',
    PPTRUB: 'PPTRUB',
    GDPEUR: 'GDPEUR',
    TCSBEUR: 'TCSBEUR',
    OPAYEUR: 'OPAYEUR',
    PRUSD: 'PRUSD',
    VPZAR: 'VPZAR',
    VPTHB: 'VPTHB',
    VPHKD: 'VPHKD',
    LVPUSD: 'LVPUSD',
    WSMUZS: 'WSMUZS',
    REYUSD: 'REYUSD',
    REYRUB: 'REYRUB',
    CSTRMTUSD: 'CSTRMTUSD',
    BTPEUR: 'BTPEUR',
    BTABKZT: 'BTABKZT',
    BTCEETH: 'BTCEETH',
    VPGPB: 'VPGPB',
    PZEUR: 'PZEUR',
    BTCELTC: 'BTCELTC',
    BTCERUB: 'BTCERUB',
    CTYBKZT: 'CTYBKZT',
    MGRUB: 'MGRUB',
    WMC: 'WMC',
    LRUSD: 'LRUSD',
    VTB24EUR: 'VTB24EUR',
    CLAM: 'CLAM',
    RBKMUSD: 'RBKMUSD',
    STPUSD: 'STPUSD',
    NIXMPPC: 'NIXMPPC',
    CSH4PUSD: 'CSH4PUSD',
    CNMTEUR: 'CNMTEUR',
    BBRUB: 'BBRUB',
    OSHBUAH: 'OSHBUAH',
    KSPBKZT: 'KSPBKZT',
    VPEUR: 'VPEUR',
    VPIDR: 'VPIDR',
    AKBBRUB: 'AKBBRUB',
    MMLEUR: 'MMLEUR',
    AGCBCNY: 'AGCBCNY',
    SMUAH: 'SMUAH',
    LRG: 'LRG',
    PMG: 'PMG',
    OKGPB: 'OKGPB',
    LREUR: 'LREUR',
    PPAUD: 'PPAUD',
    PPCAD: 'PPCAD',
    PPGBP: 'PPGBP',
    WEXUSD: 'WEXUSD',
    WEXRUB: 'WEXRUB',
    CUPCNY: 'CUPCNY',
    MMLUSD: 'MMLUSD',
    RSHBRUB: 'RSHBRUB',
    HCSBKZT: 'HCSBKZT',
    CNTUSD: 'CNTUSD',
    MNTRUB: 'MNTRUB',
    MPLEUR: 'MPLEUR',
    TMRUB: 'TMRUB',
    UKEUR: 'UKEUR',
    ANLKRUB: 'ANLKRUB',
    MPLRUB: 'MPLRUB',
    REP: 'REP',
    NIXBTC: 'NIXBTC',
    MTSBRUB: 'MTSBRUB',
    QWVRUB: 'QWVRUB',
    LQUAH: 'LQUAH',
    ECNEXUSD: 'ECNEXUSD',
    WEXBTC: 'WEXBTC',
    WEXEUR: 'WEXEUR',
    TSNBKZT: 'TSNBKZT',
    ASCTBKZT: 'ASCTBKZT',
    ALTNBKZT: 'ALTNBKZT',
    ACCUSD: 'ACCUSD',
    VPDKK: 'VPDKK',
    HMEUR: 'HMEUR',
    OCNEUR: 'OCNEUR',
    LVCRUB: 'LVCRUB',
    LVCEUR: 'LVCEUR',
    ACCIUSD: 'ACCIUSD',
    ACCIRUB: 'ACCIRUB',
    ACCIEUR: 'ACCIEUR',
    WMOUAH: 'WMOUAH',
    ABCBCNY: 'ABCBCNY',
    SMEUR: 'SMEUR',
    FPIDR: 'FPIDR',
    KIBRUB: 'KIBRUB',
    WTDEBIT: 'WTDEBIT',
    EXMBTC: 'EXMBTC',
    EXMEUR: 'EXMEUR',
    ROSBRUB: 'ROSBRUB',
    P24UAH: 'P24UAH',
    RMTFUSD: 'RMTFUSD',
    BTMUSD: 'BTMUSD',
    LSK: 'LSK',
    UKUSD: 'UKUSD',
    RNKBRUB: 'RNKBRUB',
    NTLRUSD: 'NTLRUSD',
    CNTEUR: 'CNTEUR',
    ADVCRUB: 'ADVCRUB',
    MGUSD: 'MGUSD',
    PMRXAU: 'PMRXAU',
    LVCNBTC: 'LVCNBTC',
    NIXXBL: 'NIXXBL',
    BOCUSD: 'BOCUSD',
    DTBKZKZT: 'DTBKZKZT',
    KSKNBTHB: 'KSKNBTHB',
    DKRUB: 'DKRUB',
    WIREPLN: 'WIREPLN',
    STPRUB: 'STPRUB',
    BLRBRUB: 'BLRBRUB',
    VPVEF: 'VPVEF',
    VPILS: 'VPILS',
    VPHRK: 'VPHRK',
    VPHUF: 'VPHUF',
    LPRUB: 'LPRUB',
    LPAUD: 'LPAUD',
    WTUSD: 'WTUSD',
    EURBKZT: 'EURBKZT',
    BCBCNY: 'BCBCNY',
    BTPRUB: 'BTPRUB',
    SMRUB: 'SMRUB',
    HBRUB: 'HBRUB',
    ECPZUSD: 'ECPZUSD',
    BTCUPBTC: 'BTCUPBTC',
    SWDBEUR: 'SWDBEUR',
    C4PUSD: 'C4PUSD',
    MDNDCBUSD: 'MDNDCBUSD',
    SBRCBUSD: 'SBRCBUSD',
    BCH: 'BCH',
    EPAYUSD: 'EPAYUSD',
    RMTFEUR: 'RMTFEUR',
    ANLKUSD: 'ANLKUSD',
    QWEUR: 'QWEUR',
    CASHRUB: 'CASHRUB',
    CASHCNY: 'CASHCNY',
    USTMUSD: 'USTMUSD',
    PSBRUB: 'PSBRUB',
    CGEUR: 'CGEUR',
    EPMRUB: 'EPMRUB',
    ICQM: 'ICQM',
    EDRM: 'EDRM',
    EBG: 'EBG',
    BTCUPEMC: 'BTCUPEMC',
    EDRC: 'EDRC',
    WOKZT: 'WOKZT',
    DKUSD: 'DKUSD',
    WCRUB: 'WCRUB',
    EGCUSD: 'EGCUSD',
    BLRBUSD: 'BLRBUSD',
    VPVND: 'VPVND',
    VPINR: 'VPINR',
    VPNOK: 'VPNOK',
    LVPEUR: 'LVPEUR',
    CRPTCHUSD: 'CRPTCHUSD',
    CSTRMTEUR: 'CSTRMTEUR',
    ICBCCNY: 'ICBCCNY',
    WSEUR: 'WSEUR',
    SBRKBUSD: 'SBRKBUSD',
    OBTEUR: 'OBTEUR',
    WTCARD: 'WTCARD',
    WTUSD1: 'WTUSD1',
    PXMEUR: 'PXMEUR',
    BYR: 'BYR',
    HCBRUB: 'HCBRUB',
    GCMTUSD: 'GCMTUSD',
    JMD: 'JMD',
    PMRUAH: 'PMRUAH',
    WIRELTL: 'WIRELTL',
    JOD: 'JOD',
    KES: 'KES',
    MGA: 'MGA',
    HTG: 'HTG',
    EPUSD: 'EPUSD',
    PXMUSD: 'PXMUSD',
    EEK: 'EEK',
    LTL: 'LTL',
    VPAED: 'VPAED',
    WTUSD2: 'WTUSD2',
    WMORUB: 'WMORUB',
    BTPUAH: 'BTPUAH',
    LVL: 'LVL',
    ZMK: 'ZMK',
    FETUSD: 'FETUSD',
    AGUSD: 'AGUSD',
    IMUAH: 'IMUAH',
    INCRUB: 'INCRUB',
    EMMDL: 'EMMDL',
    UMEUR: 'UMEUR',
    UMRUB: 'UMRUB',
    UMUAH: 'UMUAH',
    UMUSD: 'UMUSD',
    ARS: 'ARS',
    BHD: 'BHD',
    SBERKZT: 'SBERKZT',
    BMD: 'BMD',
    VB24UAH: 'VB24UAH',
    NIO: 'NIO',
    NMC: 'NMC',
    KYD: 'KYD',
    MVR: 'MVR',
    CARDUSD: 'CARDUSD',
    RSD: 'RSD',
    WIRERUB: 'WIRERUB',
    CASHTHB: 'CASHTHB',
    XPD: 'XPD',
    XPT: 'XPT',
    LTC: 'LTC',
    NIXUSD: 'NIXUSD',
    FPUSD: 'FPUSD',
    XAG: 'XAG',
    DZD: 'DZD',
    DKEUR: 'DKEUR',
    NNMUSD: 'NNMUSD',
    STUSD: 'STUSD',
    PPTEUR: 'PPTEUR',
    CWMRUB: 'CWMRUB',
    HLKBUSD: 'HLKBUSD',
    VPUAH: 'VPUAH',
    VPCZK: 'VPCZK',
    LPCAD: 'LPCAD',
    STLMRUB: 'STLMRUB',
    ACCEUR: 'ACCEUR',
    CPTSRUB: 'CPTSRUB',
    DTBBYR: 'DTBBYR',
    ESPBYR: 'ESPBYR',
    WIRECZK: 'WIRECZK',
    RWF: 'RWF',
    PMUSD: 'PMUSD',
    CASHUSD: 'CASHUSD',
    CTYBRUB: 'CTYBRUB',
    COP: 'COP',
    OCNBRUB: 'OCNBRUB',
    ATFBKZT: 'ATFBKZT',
    PVTMUSD: 'PVTMUSD',
    ACUAH: 'ACUAH',
    ADVCUAH: 'ADVCUAH',
    ACUSD: 'ACUSD',
    DTBUAH: 'DTBUAH',
    EDC: 'EDC',
    WOUAH: 'WOUAH',
    LQRUB: 'LQRUB',
    DASH: 'DASH',
    CARDRUB: 'CARDRUB',
    CARDGBP: 'CARDGBP',
    BND: 'BND',
    KKBKZT: 'KKBKZT',
    PNRUSD: 'PNRUSD',
    BNBRUB: 'BNBRUB',
    FWDBUAH: 'FWDBUAH',
    GRGBGEL: 'GRGBGEL',
    B1NKBKZT: 'B1NKBKZT',
    AGNDBUSD: 'AGNDBUSD',
    BALTBRUB: 'BALTBRUB',
    SPBBRUB: 'SPBBRUB',
    CRERBRUB: 'CRERBRUB',
    DMDNGBRUB: 'DMDNGBRUB',
    MSKCBRUB: 'MSKCBRUB',
    VOSTBRUB: 'VOSTBRUB',
    GRNTBTRY: 'GRNTBTRY',
    ETC: 'ETC',
    ADVCUSD: 'ADVCUSD',
    GTQ: 'GTQ',
    SKLEUR: 'SKLEUR',
    PMRRUB: 'PMRRUB',
    CARDKZT: 'CARDKZT',
    WIREEUR: 'WIREEUR',
    OPNBRUB: 'OPNBRUB',
    MZN: 'MZN',
    STPEUR: 'STPEUR',
    NTLREUR: 'NTLREUR',
    UNCBUAH: 'UNCBUAH',
    OMR: 'OMR',
    UYU: 'UYU',
    FRTBUSD: 'FRTBUSD',
    CNTRUB: 'CNTRUB',
    MGEUR: 'MGEUR',
    PPRUB: 'PPRUB',
    ZEC: 'ZEC',
    AFN: 'AFN',
    CRC: 'CRC',
    CVE: 'CVE',
    CGUSD: 'CGUSD',
    WMV: 'WMV',
    VKFBTRY: 'VKFBTRY',
    LSMKGS: 'LSMKGS',
    PAB: 'PAB',
    UZCARDUZS: 'UZCARDUZS',
    POSTBRUB: 'POSTBRUB',
    ACKZT: 'ACKZT',
    TBRUB: 'TBRUB',
    AVBRUB: 'AVBRUB',
    PEN: 'PEN',
    ATNBKZT: 'ATNBKZT',
    USTMEUR: 'USTMEUR',
    FLPNCAD: 'FLPNCAD',
    WIREUAH: 'WIREUAH',
    CASHUAH: 'CASHUAH',
    WMZ: 'WMZ',
    WMR: 'WMR',
    PMBTC: 'PMBTC',
    PPUSD: 'PPUSD',
    QWRUB: 'QWRUB',
    ALL: 'ALL',
    BAM: 'BAM',
    BOB: 'BOB',
    BWP: 'BWP',
    DJF: 'DJF',
    HNL: 'HNL',
    QWUSD: 'QWUSD',
    JPY: 'JPY',
    KHR: 'KHR',
    KMF: 'KMF',
    MMK: 'MMK',
    NGN: 'NGN',
    P24RUB: 'P24RUB',
    CARDUAH: 'CARDUAH',
    SVBRUB: 'SVBRUB',
    SBERRUB: 'SBERRUB',
    PMXAU: 'PMXAU',
    SBERUAH: 'SBERUAH',
    CARDBYN: 'CARDBYN',
    CARDAMD: 'CARDAMD',
    WIREKZT: 'WIREKZT',
    RBKMRUB: 'RBKMRUB',
    ALPCNY: 'ALPCNY',
    MMLRUB: 'MMLRUB',
    WOUSD: 'WOUSD',
    WIRECNY: 'WIRECNY',
    WIRETHB: 'WIRETHB',
    UNCBRUB: 'UNCBRUB',
    GPBRUB: 'GPBRUB',
    WORUB: 'WORUB',
    HLKBKZT: 'HLKBKZT',
    QWKZT: 'QWKZT',
    OKUSD: 'OKUSD',
    PREUR: 'PREUR',
    ANLKEUR: 'ANLKEUR',
    GCMTEUR: 'GCMTEUR',
    USTMRUB: 'USTMRUB',
    PVTMEUR: 'PVTMEUR',
    ETH: 'ETH',
    DOGE: 'DOGE',
    XMR: 'XMR',
    EMC: 'EMC',
    PMRUSD: 'PMRUSD',
    AZN: 'AZN',
    XTS: 'XTS',
    RKTBRUB: 'RKTBRUB',
    XXX: 'XXX',
    P24USD: 'P24USD',
    ACRUB: 'ACRUB',
    LQEUR: 'LQEUR',
    RFBRUB: 'RFBRUB',
    PPEUR: 'PPEUR',
    EPEUR: 'EPEUR',
    CASHAMD: 'CASHAMD',
    MOSBRUB: 'MOSBRUB',
    CASHKZT: 'CASHKZT',
    TRBRUB: 'TRBRUB',
    WUUSD: 'WUUSD',
    OKEUR: 'OKEUR',
    OKRUB: 'OKRUB',
    SKLUSD: 'SKLUSD',
    WUEUR: 'WUEUR',
    NAD: 'NAD',
    WURUB: 'WURUB',
    BSV: 'BSV',
    BTC: 'BTC',
    WME: 'WME',
    PMVUSD: 'PMVUSD',
    PXUSD: 'PXUSD',
    CARDEUR: 'CARDEUR',
    WIREUSD: 'WIREUSD',
    WMB: 'WMB',
    WMU: 'WMU',
    WMG: 'WMG',
    WIREGBP: 'WIREGBP',
    GHS: 'GHS',
    WMX: 'WMX',
    WMK: 'WMK',
    AED: 'AED',
    ISK: 'ISK',
    CUP: 'CUP',
    YAMRUB: 'YAMRUB',
    PMEUR: 'PMEUR',
    LQUSD: 'LQUSD',
    PHP: 'PHP',
    SGD: 'SGD',
    SOS: 'SOS',
    BDT: 'BDT',
    BIF: 'BIF',
    CZK: 'CZK',
    PYG: 'PYG',
    UGX: 'UGX',
    GRN: 'GRN',
    ADA: 'ADA',
    BNB: 'BNB'
};
exports.CurrencyCode = CurrencyCode;
